module.exports = __webpack_public_path__ + "static/media/bio_will_4.a717eb13.jpg";